// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner-module__spinner___3CRZi","load4":"Spinner-module__load4___2EnlN"};